export const slackApiPaths = <const>{
    authCompleteConnect: 'auth/complete-connect-to-am',
    authCompleteConnectUser: 'auth/complete-connect-user-to-am',
    authCompleteInstall: 'auth/complete-install-to-ws',
    authConnectUser: 'auth/connect-user-to-am',
};
